import "./styles.css";
import React, { Component } from "react";
import { Table, Accordion, Icon, Transition, Button } from "semantic-ui-react";

class InfoFormDataDisplay extends Component {
  state = { activeIndex: -1 };
  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });
  };
  render() {
    const { formInfo, goToStepOne, goToStepZero, letter, radio } = this.props;
    const { activeIndex } = this.state;
    return (
      <Accordion styled style={{ width: "100%" }}>
        <Accordion.Title
          active={activeIndex === 0}
          index={0}
          onClick={this.handleClick}
          className="checkout-accordion-title-container"
        >
          <div>
            <span style={{ fontSize: 11 }}>Información del comprador</span>
            <div className="float-right">
              {activeIndex === 0 ? (
                <Icon name="minus" size="small" />
              ) : (
                <Icon name="plus" size="small" />
              )}
            </div>
          </div>
        </Accordion.Title>
        <Transition
          visible={activeIndex === 0}
          animation="slide down"
          duration={500}
        >
          <Accordion.Content active={activeIndex === 0}>
            <Table definition textAlign="center">
              <Table.Body>
                <Table.Row>
                  <Table.Cell width={5}>Nombres</Table.Cell>
                  <Table.Cell className="form-info-data-tablecell">
                    {formInfo.names ? formInfo.names.value : ""}
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Apellidos</Table.Cell>
                  <Table.Cell className="form-info-data-tablecell">
                    {formInfo.surnames ? formInfo.surnames.value : ""}
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Correo electrónico</Table.Cell>
                  <Table.Cell className="form-info-data-tablecell">
                    {formInfo.email ? formInfo.email.value : ""}
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Teléfono móvil</Table.Cell>
                  <Table.Cell className="form-info-data-tablecell">
                    {formInfo.code ? formInfo.code.value : ""}{" "}
                    {formInfo.phone ? formInfo.phone.value : ""}
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
            <div className="edit-cart-link-container">
              <Button className="btn" size="tiny" onClick={goToStepZero}>
                Editar
              </Button>
            </div>
          </Accordion.Content>
        </Transition>
        <Accordion.Title
          active={activeIndex === 1}
          index={1}
          onClick={this.handleClick}
          className="checkout-accordion-title-container"
        >
          <div>
            <span style={{ fontSize: 11 }}>Información de envío</span>

            <div className="float-right">
              {activeIndex === 1 ? (
                <Icon name="minus" size="small" />
              ) : (
                <Icon name="plus" size="small" />
              )}
            </div>
          </div>
        </Accordion.Title>
        <Transition
          visible={activeIndex === 1}
          animation="slide down"
          duration={500}
        >
          <Accordion.Content active={activeIndex === 1}>
            <Table definition textAlign="center">
              <Table.Body>
                <Table.Row>
                  <Table.Cell>
                    Nombre de la persona que recibirá las flores
                  </Table.Cell>
                  <Table.Cell className="form-info-data-tablecell">
                    {formInfo.recipientName ? formInfo.recipientName.value : ""}
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>
                    Teléfono móvil de la persona que recibirá las flores
                  </Table.Cell>
                  <Table.Cell className="form-info-data-tablecell">
                    {formInfo.recipientCode ? formInfo.recipientCode.value : ""}{" "}
                    {formInfo.recipientPhone
                      ? formInfo.recipientPhone.value
                      : ""}
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell width={5}>Dirección de envío</Table.Cell>
                  <Table.Cell className="form-info-data-tablecell">
                    {formInfo.addressLine1 ? formInfo.addressLine1.value : ""}
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Dirección de envío (continuación)</Table.Cell>
                  <Table.Cell className="form-info-data-tablecell">
                    {formInfo.addressLine2 ? formInfo.addressLine2.value : ""}
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Departamento</Table.Cell>
                  <Table.Cell className="form-info-data-tablecell">
                    {formInfo.department?.value
                      ? formInfo.department?.value
                      : ""}
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Ciudad o municipio</Table.Cell>
                  <Table.Cell className="form-info-data-tablecell">
                    {formInfo.municipality?.value
                      ? formInfo.municipality?.value
                      : ""}
                  </Table.Cell>
                </Table.Row>
                {/* <Table.Row>
                  <Table.Cell>Código postal</Table.Cell>
                  <Table.Cell className="form-info-data-tablecell">
                    {formInfo.postal && formInfo.postal.value}
                  </Table.Cell>
                </Table.Row> */}
                <Table.Row>
                  <Table.Cell>Dedicatoria</Table.Cell>
                  <Table.Cell className="form-info-data-tablecell">
                    {letter}
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>
                    ¿Su nombre aparecerá en la dedicatoria?
                  </Table.Cell>
                  <Table.Cell className="form-info-data-tablecell">
                    {radio === "true" ? "Si" : "No"}
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
            <div className="edit-cart-link-container">
              <Button className="btn" size="tiny" onClick={goToStepOne}>
                Editar
              </Button>
            </div>
          </Accordion.Content>
        </Transition>
      </Accordion>
    );
  }
}
export default InfoFormDataDisplay;
